import type { ExcJpmamV1JpmamOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const JPMAM_ORDER_BASE_PATH = getResolvedPath('/clearing/vendor/jpm/order');

export const getJpmamOrderPath: EntityPathBuilder<ExcJpmamV1JpmamOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JPMAM_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.orderId) {
        return undefined;
      }

      return getResolvedPath(`${JPMAM_ORDER_BASE_PATH}/$orderId`, context.keys);
    }
  }
};

export function getJpmamOrderDetailPath(orderId: string | undefined) {
  if (!orderId) {
    return undefined;
  }

  return getJpmamOrderPath({ kind: 'detail', keys: { orderId } });
}

